import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

// Specific imports: the state barrel reaches back into UI hooks (useGetContextNodeActions),
// which would create import cycles for anything under it that needs the active language.
import { setActiveLanguageCodeAction } from "../state/appConfig/appConfigActions.ts";
import { activeLanguageSelector } from "../state/contextualSelectors/activeLanguageSelectors.ts";
import { activeContentLanguageCodeSelector } from "../state/contextualSelectors/appConfigSelectors.ts";

export const useActiveContentLanguageCode = () => useSelector(activeLanguageSelector);

export const useActiveLanguageCode = () => useSelector(activeContentLanguageCodeSelector);

export const useSetActiveContentLanguageCode = () => {
  const dispatch = useDispatch();
  const stateActiveLanguageCode = useSelector(activeContentLanguageCodeSelector);

  useEffect(() => {
    return window.interact.subscribe(() => {
      const urlLang = window.interact.getLang();
      if (urlLang && urlLang !== stateActiveLanguageCode) {
        dispatch(setActiveLanguageCodeAction(urlLang));
      }
    });
  }, [dispatch, stateActiveLanguageCode]);

  return useCallback(
    (lang: string) => {
      window.interact.setLang(lang);
      dispatch(setActiveLanguageCodeAction(lang));
    },
    [dispatch],
  );
};
